import { useState } from 'react';

export const useShowMore = <T extends Record<string, boolean>>(
  defaultState: T,
) => {
  const [showMore, setShowMore] = useState<T>(defaultState);

  const toggleShowMore = (key: keyof T) => () => {
    setShowMore((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  return {
    showMore,
    toggleShowMore,
  };
};
